import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { OAuthClient, OAuthClientAuth, OAuthCounters } from '@recruitee/http-types';

export interface AuthorizePayload {
  responseType: 'code';
  clientId: number;
  scope: string;
  redirectUri: string;
}

@Injectable({ providedIn: 'root' })
export class OAuthHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadClient(id: number | string): Observable<OAuthClient> {
    return this.httpApi.get(`/oauth/clients/${id}`).pipe(map(data => data.client));
  }

  public loadClientAuths(): Observable<OAuthClientAuth[]> {
    return this.httpApi.get(`/oauth/client_auths`).pipe(map(data => data.clientAuths));
  }

  public loadClientAuthCounters(): Observable<OAuthCounters> {
    return this.httpApi.get(`/oauth/client_auths/counters`).pipe(map(data => data.counters));
  }

  public authorize({ clientId, ...params }: AuthorizePayload): Observable<{ code: string }> {
    return this.httpApi.post(`/oauth/clients/${clientId}/authorize`, null, params);
  }

  public deauthorize(clientId: number | string): Observable<void> {
    return this.httpApi.post(`/oauth/clients/${clientId}/deauthorize`);
  }
}
